<script>

    import { toast } from 'bulma-toast'
    import { providersStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import ProvidersService from '../$services/providers.service'
    import TranslateMethods from '../$methods/translate.methods'

    import Search from '../$components/input.search.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Table from '../$components/table.svelte'

    let loading = false
    let query = {}

    getProviders()

    async function getProviders() {

        loading = true
        const resp = await ProvidersService.getProviders(null)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        providersStore.set(resp.data)
    }

</script>

<Table items={ $providersStore.length } { loading } skeletonCols={4}>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getProviders } />
            {#if isPermission($adminStore, 'SettingsView.Provider.Create')}
                <ButtonModal modalId="provider_create_modal" icon="plus" text="Agregar"/>
            {/if}
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Proveedor</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $providersStore as provider, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ TranslateMethods.get(provider.status) }</td>
                <td>{ provider.name }</td>
                <td>
                    <Button on:click={() => modalStore.open('provider', 'modal', provider)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
